import metaResponse from "../Config/metaResponse"; //META RESPONSE (ALTERNATIVE)

//main store
const initialState={
    termInserted: "",
    receivedData: {}
}
//root reducer
const rootReducer =(state = initialState, action)=>{
    switch (action.type){
        case "CHANGE_TERM":
            return{
                 ...state,
                 termInserted: action.payload
            }
        case "UPDATE_DATA":
           
            return{
                ...state,
                // receivedData: metaResponse
                receivedData: action.payload?.error?.code === 429 ? metaResponse : action.payload
            }
        
        case "CLEAR_INPUT":
            return{
                ...state,
                termInserted: ""
            }
        default :
           return state;
    }
}
export default rootReducer;